import React, { useState, useEffect } from 'react';
import Post from "../../../../../utils/Post";
import { getUser } from '../../../../../utils/Common';
import { get, set } from 'lodash';

const ContenedorCamaFumigacion = (p) => {
    const actualizarPadre = p.actualizarPadre ?? (() => { });
    const valvula = p.valvula ?? 0;
    const cama = p.cama ?? 0;
    const fecha = p.fecha;
    const [refuerzo, setrefuerzo] = useState(p.refuerzo);
    const [classCama, setclassCama] = useState('m-1 p-0 contenedor border round-s bg-light');
    const estiloCargando = 'm-1 p-0  contenedor border border-2 scale-continue-05 round-m bg-light border-warning text-bold';
    const [listoParaUsar, setlistoParaUsar] = useState(false);
    const usuarioSistemaID = getUser().id;
    const usuarioSistemaTipo = getUser().perfil.nombre.toLowerCase();

    useEffect(() => {
        setclassCama(estiloCargando);
        setrefuerzo(p.refuerzo);
        refrescarEstilo(p.refuerzo);
    }, [p.refuerzo]);

    const puedeEditar = (ref = refuerzo) => {
        let puedeUsar = (!ref || ref.usuario === usuarioSistemaID || ['administrador', 'usuario'].includes(usuarioSistemaTipo));
        setlistoParaUsar(puedeUsar);
        return puedeUsar;
    }

    const refrescarEstilo = async (ref = refuerzo) => {
        setclassCama(estiloPorDefecto(ref))
        puedeEditar();

    }

    const switchAvance = async () => {
        if (!listoParaUsar || !puedeEditarTipoUsuario()) return;
        setlistoParaUsar(false);
        setclassCama(estiloCargando);
        let resp = await actualizarPadre('actualizar cama', { cama: cama, valvula: valvula, fecha: fecha });
        refrescarEstilo(p.refuerzo);
    }

    const estiloPorDefecto = (ref = refuerzo) => {
        if (ref) return 'm-1 p-0  contenedor border round-s bg-warning text-bold';
        return 'm-1 p-0 contenedor border round-s bg-light';
    }

    const puedeEditarTipoUsuario = () => {
        if (!refuerzo) return true;
        if (['administrador', 'usuario'].includes(usuarioSistemaTipo)) return true;
        if (+refuerzo.usuario === +usuarioSistemaID) return true;
        return false;
    }

    const refuersoMismoUsuario = () => {
        if (!refuerzo) return true;
        if (refuerzo.usuario === usuarioSistemaID) return true;
        return false;
    }


    return (
        <div className={classCama + (listoParaUsar && puedeEditarTipoUsuario() ? " pointer" : "") + (!refuersoMismoUsuario() ? ' opacity-50' : '')} style={{ width: '30px', height: "30px" }} onClick={switchAvance}>
            {cama}
        </div>
    )
}

export default ContenedorCamaFumigacion;